import React from 'react'
import { STATUS } from './utils/constants/statuses'
import { buildArticleUrl } from './utils/urlUtils'
import {
  RequirementActions,
  ActionButton,
  ActionButtonText,
  TextButton
} from './Styles/ProgressTracker.styles'

const RequirementActionLinks = ({ displayData, requirementStatus }) => {
  const hasPrimaryLink = displayData.primaryLinkText && displayData.primaryLinkUrl
  const hasSecondaryLink = displayData.secondaryLinkText && displayData.secondaryLinkUrl
  const hasActionLink = hasPrimaryLink || hasSecondaryLink
  const isActionable = requirementStatus !== STATUS.LOCKED

  if (!hasActionLink || !isActionable) {
    return null
  }

  return (
    <RequirementActions>
      {hasPrimaryLink && (
        <ActionButton
          as="a"
          href={displayData.primaryLinkUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ActionButtonText>
            {displayData.primaryLinkText}
          </ActionButtonText>
        </ActionButton>
      )}
      {hasSecondaryLink && (
        <TextButton
          as="a"
          href={buildArticleUrl(displayData.secondaryLinkUrl)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {displayData.secondaryLinkText}
        </TextButton>
      )}
    </RequirementActions>
  )
}

export default RequirementActionLinks

